export const NAV_LINKS = [
  { id: "benefits", label: "Features" },
  { id: "how-it-works", label: "How it works" },
  { id: "calculator", label: "Calculator" },
  { id: "pricing", label: "Pricing" },
  { id: "downloads", label: "Downloads" },
  { id: "faq", label: "FAQ" },
];

// Footer lists every on-page section, including the ones kept out of the
// top nav to stop it wrapping.
export const FOOTER_LINKS = [
  { id: "benefits", label: "Features" },
  { id: "how-it-works", label: "How it works" },
  { id: "results", label: "Community" },
  { id: "calculator", label: "Calculator" },
  { id: "pricing", label: "Pricing" },
  { id: "why-now", label: "Why now" },
  { id: "free-access", label: "Free access" },
  { id: "downloads", label: "Downloads" },
  { id: "faq", label: "FAQ" },
];

export const ENQUIRY_TOPICS = [
  { value: "general", label: "General question" },
  { value: "licence", label: "Licence and pricing" },
  { value: "setup", label: "Setup or install help" },
  { value: "free-access", label: "Free access" },
  { value: "source-code", label: "Source code" },
];

export const STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "in-progress", label: "In progress" },
  { value: "done", label: "Done" },
  { value: "rejected", label: "Rejected" },
];

export const RISK_DISCLAIMER =
  "Trading leveraged products such as gold CFDs carries a high level of risk and can result in the loss of all your capital. Goldmap EA is a tool that follows the rules you configure - it is not investment advice, it does not guarantee profit, and past behaviour never guarantees future results. Only trade money you can genuinely afford to lose.";
